import React from 'react';

// NULA MOVE · ADMIN navigation restructure — placeholder for sections whose
// navigation slot is built now (Phase 1: layout, nav, country selector,
// role visibility) but whose real content is explicitly later-phase work
// per the client's own suggested order (Task Inbox + global search = Phase
// 3; Bookings & Finance, support tickets, Integrations & API = Phase 4).
const ComingSoon = ({ title, description }) => (
  <div style={{ padding: 32, maxWidth: 640 }}>
    <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 10 }}>{title}</h1>
    <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.6 }}>{description}</p>
    <div style={{ marginTop: 16, padding: 14, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, color: '#92400e', fontSize: 13 }}>
      This section's place in the navigation is live. Its content is scheduled for a later phase.
    </div>
  </div>
);

export default ComingSoon;
